import React, { useRef, useState, useEffect } from 'react';

import { useTranslation } from '@common/hooks/translation';

import './style.scss';

const ProfitBoostInfo = ({ closePopup }) => {
  const t = useTranslation();
  const [startPosition, setStartPosition] = useState(null);
  const [endPosition, setEndPosition] = useState(null);
  const starsRef = useRef();

  useEffect(() => {
    const betslipStars = document.getElementById('betslip-profit-boost-stars');

    if (betslipStars) {
      betslipStars.style.opacity = 0;

      return () => {
        betslipStars.style.opacity = 1;
      };
    }
  }, []);

  const triggerAniamtion = () => {
    const startRect = starsRef.current?.getBoundingClientRect();
    const endRect = document.getElementById('betslip-profit-boost-stars')?.getBoundingClientRect();

    if (startRect && endRect) {
      setStartPosition({ x: startRect.left, y: startRect.top });
      setTimeout(() => {
        setEndPosition({ x: endRect.left - startRect.left, y: endRect.top - startRect.top });
        setTimeout(() => closePopup(), 2000);
      }, 0);
    } else closePopup();
  };

  return (
    startPosition ? (
      <div
        className="profit-boost-info-stars stars-animating"
        style={{
          left: startPosition.x,
          top: startPosition.y,
          transform: endPosition ? `translate(${endPosition.x}px, ${endPosition.y}px)` : '',
        }}
      />
    ) : (
      <div className="popup-content popup-small profit-boost-info-popup">
        <div className="profit-boost-info-stars" id="app-pofit-boost-stars" ref={starsRef} />
        <div className="popup-title">{t('Profit Boost')}</div>

        <div className="popup-main-content">
          <p>{t('You\'ve successfully claimed a profit boost! Just place one more bet to unlock and use it.')}</p>
        </div>

        <button className="popup-confirm-button" onClick={triggerAniamtion} type="button">
          {t('Got it')}
        </button>
      </div>
    )
  );
};

export default ProfitBoostInfo;
